import React, { useState, useEffect, useCallback } from "react";
import BetaNavbar from "./components/BetaNavbar";
import ManufacturingHero from "./components/Manufacturing/ManufacturingHero";
import ManufacturingTabbedSection from "./components/Manufacturing/ManufacturingTabbedSection";
import betaAPI from "v2/api";

const ManufacturingDashboard = () => {
  const [stats, setStats] = useState({
    totalBatches: 0,
    totalWearables: 0,
    deployed: 0,
    scrapped: 0,
  });

  const fetchStats = useCallback(async () => {
    try {
      const [batchesRes, wearablesRes, deployedRes, scrappedRes] =
        await Promise.all([
          betaAPI.getBatches({ page: 1, pageSize: 1 }),
          betaAPI.getWearables({ page: 1, pageSize: 1 }),
          betaAPI.getWearables({ page: 1, pageSize: 1, status: "deployed" }),
          betaAPI.getWearables({ page: 1, pageSize: 1, status: "scrapped" }),
        ]);

      setStats({
        totalBatches: batchesRes.data?.total_count ?? 0,
        totalWearables: wearablesRes.data?.total_count ?? 0,
        deployed: deployedRes.data?.total_count ?? 0,
        scrapped: scrappedRes.data?.total_count ?? 0,
      });
    } catch (error) {
      console.error("Failed to fetch manufacturing stats:", error);
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <div className="min-h-screen overscroll-none bg-[#F8F9FA]">
      <BetaNavbar hideWorkspaceSelector />

      <main>
        <div
          style={{
            background:
              "linear-gradient(180deg, rgba(232, 133, 74, 0.08) 0%, rgba(232, 133, 74, 0.03) 50%, rgba(255, 255, 255, 0) 100%)",
          }}
        >
          <div className="mx-auto max-w-[1440px]">
            <ManufacturingHero stats={stats} />
          </div>
        </div>

        <div className="mx-auto max-w-[1440px] px-6 pb-6">
          <ManufacturingTabbedSection onDataChange={fetchStats} />
        </div>
      </main>
    </div>
  );
};

export default ManufacturingDashboard;
